export const ESPOT_MANUAL_APPROVAL_MESSAGE = 'ManualApprovalMessage';
export const CUSTOM_OUTAGE_MESSAGE = 'CUSTOM_OUTAGE_MESSAGE';

export const ESPOT_NAMES = [
  'OUTAGE_MESSAGE',
  'CATSAS_PCC_ALL_DEALER_CMC_ESPOT_OUTAGE_MESSAGE'
];

export const ESPOT_MANUAL_APPROVAL_MESSAGE_VIEWED = 'viewed';

export const SELECT_OR_ADD_EQUIPMENT = {
  src: 'https://caterpillar.scene7.com/is/image/Caterpillar/CM20240314-601e6-1c83d',
  alt: 'Select or Add Equipment',
  width: 180,
  height: 120
};

export const NO_EXACT_MATCH_IMAGE_SIZE = {
  width: 140,
  height: 93
};

export const DEEP_LINK_ROUTE = 'deeplink';
export const HOMEPAGE_SEARCH_BAR_BANNER = 'search-bar-banner-homepage';
export const MULTI_EQUIPMENT_ROUTE = 'multiEquipmentRoute';
